import * as firebase from "firebase";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCG1iDqTtzVh_yZLUodO3QC6xMR8ITThFU",
  authDomain: "meditation-2a453.firebaseapp.com",
  databaseURL: "https://meditation-2a453.firebaseio.com",
  projectId: "meditation-2a453",
  storageBucket: "meditation-2a453.appspot.com",
  messagingSenderId: "22610436155",
  appId: "1:22610436155:web:799d7c7aff7ae6fd2a7c1e",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
